import {useState, useEffect} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import './style.css'
import DashboardCards from './DashboardCards'
import SearchFilterBar from './SearchFilterBar'
import AlumniTable from './AlumniTable'
const api = new Api()

const DashboardContent = () => {
  const [query, setQuery] = useState({})
  const [statistic, setStatistic] = useState({})

  const handleInputFilter = (data: any) => {
    setQuery(data)
  }

  const handleStatistic = (data: any) => {
    setStatistic(data)
  }

  return (
    <div className='row'>
      <DashboardCards statistic={statistic} />

      <div className='px-3 pt-5'>
        <SearchFilterBar
          handleInputFilter={handleInputFilter}
          status={['Menunggu Review', 'Ditolak']}
          statusName='status'
        />
      </div>

      <div className='px-3 pt-5'>
        <AlumniTable dataFilter={query} handleStatistic={handleStatistic} />
      </div>
    </div>
  )
}

const PengajuanProfile = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Frop',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Pengajuan Alumni
      </PageTitle>
      <DashboardContent />
    </>
  )
}

export default PengajuanProfile
